import ReactSlider from 'react-slider';
import PropTypes from 'prop-types';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var OpacitySlider = function OpacitySlider(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return /*#__PURE__*/_jsx(ReactSlider, {
    value: value,
    onChange: onChange,
    className: "ptr-OpacitySlider",
    thumbClassName: "ptr-OpacitySlider-thumb",
    trackClassName: "ptr-OpacitySlider-track"
  });
};

OpacitySlider.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func
};
export default OpacitySlider;